import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_2 = { class: "p-5 text-center" }
const _hoisted_3 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "px-5 pb-8 text-center" }
const _hoisted_6 = { class: "col-span-12 2xl:col-span-9" }
const _hoisted_7 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_8 = { class: "col-span-12 mt-8" }
const _hoisted_9 = { class: "flex items-center h-10 intro-y" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, "General Report", -1)
const _hoisted_11 = ["data-intro"]
const _hoisted_12 = {
  href: "/management",
  class: "flex items-center ml-auto text-primary"
}
const _hoisted_13 = { class: "grid grid-cols-12 gap-6 mt-5" }
const _hoisted_14 = { class: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y" }
const _hoisted_15 = {
  class: /*#__PURE__*/_normalizeClass([
                  'relative zoom-in',
                  'before:content-[\'\'] before:w-[90%] before:shadow-[0px_3px_20px_#0000000b] before:bg-slate-50 before:h-full before:mt-3 before:absolute before:rounded-md before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/70',
                ])
}
const _hoisted_16 = { class: "p-5 box" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = { class: "ml-auto" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-3xl font-medium leading-8" }, "4.710", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-base text-slate-500" }, "Item Sales", -1)
const _hoisted_21 = { class: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y" }
const _hoisted_22 = {
  class: /*#__PURE__*/_normalizeClass([
                  'relative zoom-in',
                  'before:content-[\'\'] before:w-[90%] before:shadow-[0px_3px_20px_#0000000b] before:bg-slate-50 before:h-full before:mt-3 before:absolute before:rounded-md before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/70',
                ])
}
const _hoisted_23 = { class: "p-5 box" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "ml-auto" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-3xl font-medium leading-8" }, "3.721", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-base text-slate-500" }, "New Orders", -1)
const _hoisted_28 = { class: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y" }
const _hoisted_29 = {
  class: /*#__PURE__*/_normalizeClass([
                  'relative zoom-in',
                  'before:content-[\'\'] before:w-[90%] before:shadow-[0px_3px_20px_#0000000b] before:bg-slate-50 before:h-full before:mt-3 before:absolute before:rounded-md before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/70',
                ])
}
const _hoisted_30 = { class: "p-5 box" }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "ml-auto" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-3xl font-medium leading-8" }, "2.149", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-base text-slate-500" }, " Total Products ", -1)
const _hoisted_35 = { class: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y" }
const _hoisted_36 = {
  class: /*#__PURE__*/_normalizeClass([
                  'relative zoom-in',
                  'before:content-[\'\'] before:w-[90%] before:shadow-[0px_3px_20px_#0000000b] before:bg-slate-50 before:h-full before:mt-3 before:absolute before:rounded-md before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/70',
                ])
}
const _hoisted_37 = { class: "p-5 box" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "ml-auto" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-3xl font-medium leading-8" }, "152.040", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-base text-slate-500" }, " Unique Visitor ", -1)
const _hoisted_42 = { class: "col-span-12 mt-8 lg:col-span-6" }
const _hoisted_43 = { class: "items-center block h-10 intro-y sm:flex" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, "Sales Report", -1)
const _hoisted_45 = { class: "relative mt-3 sm:ml-auto sm:mt-0 text-slate-500" }
const _hoisted_46 = { class: "p-5 mt-12 intro-y box sm:mt-5" }
const _hoisted_47 = { class: "flex flex-col md:flex-row md:items-center" }
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"flex\"><div><div class=\"text-lg font-medium text-primary dark:text-slate-300 xl:text-xl\"> $15,000 </div><div class=\"mt-0.5 text-slate-500\">This Month</div></div><div class=\"w-px h-12 mx-4 border border-r border-dashed border-slate-200 dark:border-darkmode-300 xl:mx-5\"></div><div><div class=\"text-lg font-medium text-slate-500 xl:text-xl\"> $10,000 </div><div class=\"mt-0.5 text-slate-500\">Last Month</div></div></div>", 1)
const _hoisted_49 = {
  class: /*#__PURE__*/_normalizeClass([
                'relative',
                'before:content-[\'\'] before:block before:absolute before:w-16 before:left-0 before:top-0 before:bottom-0 before:ml-10 before:mb-7 before:bg-gradient-to-r before:from-white before:via-white/80 before:to-transparent before:dark:from-darkmode-600',
                'after:content-[\'\'] after:block after:absolute after:w-16 after:right-0 after:top-0 after:bottom-0 after:mb-7 after:bg-gradient-to-l after:from-white after:via-white/80 after:to-transparent after:dark:from-darkmode-600',
              ])
}
const _hoisted_50 = { class: "col-span-12 mt-8 sm:col-span-6 lg:col-span-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center h-10 intro-y" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, "Weekly Top Seller"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    class: "ml-auto truncate text-primary"
  }, " Show More ")
], -1)
const _hoisted_52 = { class: "p-5 mt-5 intro-y box" }
const _hoisted_53 = { class: "mt-3" }
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"mx-auto mt-8 w-52 sm:w-auto\"><div class=\"flex items-center\"><div class=\"w-2 h-2 mr-3 rounded-full bg-primary\"></div><span class=\"truncate\">17 - 30 Years old</span><span class=\"ml-auto font-medium\">62%</span></div><div class=\"flex items-center mt-4\"><div class=\"w-2 h-2 mr-3 rounded-full bg-pending\"></div><span class=\"truncate\">31 - 50 Years old</span><span class=\"ml-auto font-medium\">33%</span></div><div class=\"flex items-center mt-4\"><div class=\"w-2 h-2 mr-3 rounded-full bg-warning\"></div><span class=\"truncate\">&gt;= 50 Years old</span><span class=\"ml-auto font-medium\">10%</span></div></div>", 1)
const _hoisted_55 = { class: "col-span-12 mt-8 sm:col-span-6 lg:col-span-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center h-10 intro-y" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, "Sales Report"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    class: "ml-auto truncate text-primary"
  }, " Show More ")
], -1)
const _hoisted_57 = { class: "p-5 mt-5 intro-y box" }
const _hoisted_58 = { class: "mt-3" }
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<div class=\"mx-auto mt-8 w-52 sm:w-auto\"><div class=\"flex items-center\"><div class=\"w-2 h-2 mr-3 rounded-full bg-primary\"></div><span class=\"truncate\">17 - 30 Years old</span><span class=\"ml-auto font-medium\">62%</span></div><div class=\"flex items-center mt-4\"><div class=\"w-2 h-2 mr-3 rounded-full bg-pending\"></div><span class=\"truncate\">31 - 50 Years old</span><span class=\"ml-auto font-medium\">33%</span></div><div class=\"flex items-center mt-4\"><div class=\"w-2 h-2 mr-3 rounded-full bg-warning\"></div><span class=\"truncate\">&gt;= 50 Years old</span><span class=\"ml-auto font-medium\">10%</span></div></div>", 1)
const _hoisted_60 = { class: "col-span-12 mt-6 xl:col-span-8" }
const _hoisted_61 = { class: "items-center block h-10 intro-y sm:flex" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, "Official Store", -1)
const _hoisted_63 = { class: "relative mt-3 sm:ml-auto sm:mt-0 text-slate-500" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "p-5 mt-12 intro-y box sm:mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, " 250 Official stores in 21 countries, click the marker to see location details. ")
], -1)
const _hoisted_65 = { class: "col-span-12 mt-6 xl:col-span-4" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center h-10 intro-y" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, " Weekly Best Sellers ")
], -1)
const _hoisted_67 = { class: "mt-5" }
const _hoisted_68 = { class: "flex items-center px-4 py-4 mb-3 box zoom-in" }
const _hoisted_69 = { class: "flex-none w-10 h-10 overflow-hidden rounded-md image-fit" }
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "ml-4 mr-auto" }
const _hoisted_72 = { class: "font-medium" }
const _hoisted_73 = { class: "text-slate-500 text-xs mt-0.5" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "px-2 py-1 text-xs font-medium text-white rounded-full cursor-pointer bg-success" }, " 137 Sales ", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "block w-full py-4 text-center border border-dotted rounded-md intro-y border-slate-400 dark:border-darkmode-300 text-slate-500"
}, " View More ", -1)
const _hoisted_76 = { class: "grid grid-cols-12 col-span-12 gap-6 mt-8" }
const _hoisted_77 = { class: "col-span-12 sm:col-span-6 2xl:col-span-3 intro-y" }
const _hoisted_78 = { class: "p-5 box zoom-in" }
const _hoisted_79 = { class: "flex items-center" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "flex-none w-2/4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-medium truncate" }, "Target Sales"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-slate-500" }, "300 Sales")
], -1)
const _hoisted_81 = { class: "relative flex-none ml-auto" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 flex items-center justify-center w-full h-full font-medium" }, " 20% ", -1)
const _hoisted_83 = { class: "col-span-12 sm:col-span-6 2xl:col-span-3 intro-y" }
const _hoisted_84 = { class: "p-5 box zoom-in" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-3 text-lg font-medium truncate" }, " Social Media "),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center px-2 py-1 ml-auto text-xs truncate rounded-full cursor-pointer bg-slate-100 dark:bg-darkmode-400 text-slate-500" }, " 320 Followers ")
], -1)
const _hoisted_86 = { class: "mt-1" }
const _hoisted_87 = { class: "col-span-12 sm:col-span-6 2xl:col-span-3 intro-y" }
const _hoisted_88 = { class: "p-5 box zoom-in" }
const _hoisted_89 = { class: "flex items-center" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "flex-none w-2/4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-medium truncate" }, "New Products"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-slate-500" }, "1450 Products")
], -1)
const _hoisted_91 = { class: "relative flex-none ml-auto" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 flex items-center justify-center w-full h-full font-medium" }, " 45% ", -1)
const _hoisted_93 = { class: "col-span-12 sm:col-span-6 2xl:col-span-3 intro-y" }
const _hoisted_94 = { class: "p-5 box zoom-in" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-3 text-lg font-medium truncate" }, "Posted Ads"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center px-2 py-1 ml-auto text-xs truncate rounded-full cursor-pointer bg-slate-100 dark:bg-darkmode-400 text-slate-500" }, " 180 Campaign ")
], -1)
const _hoisted_96 = { class: "mt-1" }
const _hoisted_97 = { class: "col-span-12 mt-6" }
const _hoisted_98 = { class: "items-center block h-10 intro-y sm:flex" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, " Weekly Top Products ", -1)
const _hoisted_100 = { class: "flex items-center mt-3 sm:ml-auto sm:mt-0" }
const _hoisted_101 = { class: "mt-8 overflow-auto intro-y lg:overflow-visible sm:mt-0" }
const _hoisted_102 = { class: "flex" }
const _hoisted_103 = { class: "w-10 h-10 image-fit zoom-in" }
const _hoisted_104 = { class: "w-10 h-10 -ml-5 image-fit zoom-in" }
const _hoisted_105 = { class: "w-10 h-10 -ml-5 image-fit zoom-in" }
const _hoisted_106 = {
  href: "",
  class: "font-medium whitespace-nowrap"
}
const _hoisted_107 = { class: "text-slate-500 text-xs whitespace-nowrap mt-0.5" }
const _hoisted_108 = { class: "flex items-center justify-center" }
const _hoisted_109 = {
  class: "flex items-center mr-3",
  href: ""
}
const _hoisted_110 = {
  class: "flex items-center text-danger",
  href: ""
}
const _hoisted_111 = { class: "flex flex-wrap items-center mt-3 intro-y sm:flex-row sm:flex-nowrap" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("option", null, "10", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("option", null, "25", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("option", null, "35", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("option", null, "50", -1)
const _hoisted_116 = { class: "col-span-12 2xl:col-span-3" }
const _hoisted_117 = { class: "pb-10 -mb-10 2xl:border-l" }
const _hoisted_118 = { class: "grid grid-cols-12 2xl:pl-6 gap-x-6 2xl:gap-x-0 gap-y-6" }
const _hoisted_119 = { class: "col-span-12 mt-3 md:col-span-6 xl:col-span-4 2xl:col-span-12 2xl:mt-8" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center h-10 intro-x" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, "Transactions")
], -1)
const _hoisted_121 = { class: "mt-5" }
const _hoisted_122 = { class: "flex items-center px-5 py-3 mb-3 box zoom-in" }
const _hoisted_123 = { class: "flex-none w-10 h-10 overflow-hidden rounded-full image-fit" }
const _hoisted_124 = ["src"]
const _hoisted_125 = { class: "ml-4 mr-auto" }
const _hoisted_126 = { class: "font-medium" }
const _hoisted_127 = { class: "text-slate-500 text-xs mt-0.5" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "block w-full py-3 text-center border border-dotted rounded-md intro-x border-slate-400 dark:border-darkmode-300 text-slate-500"
}, " View More ", -1)
const _hoisted_129 = { class: "col-span-12 mt-3 md:col-span-6 xl:col-span-4 2xl:col-span-12" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center h-10 intro-x" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, " Recent Activities "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    class: "ml-auto truncate text-primary"
  }, " Show More ")
], -1)
const _hoisted_131 = { class: "mt-5 relative before:block before:absolute before:w-px before:h-[85%] before:bg-slate-200 before:dark:bg-darkmode-400 before:ml-5 before:mt-5" }
const _hoisted_132 = { class: "relative flex items-center mb-3 intro-x" }
const _hoisted_133 = { class: "before:block before:absolute before:w-20 before:h-px before:bg-slate-200 before:dark:bg-darkmode-400 before:mt-5 before:ml-5" }
const _hoisted_134 = { class: "flex-none w-10 h-10 overflow-hidden rounded-full image-fit" }
const _hoisted_135 = ["src"]
const _hoisted_136 = { class: "flex-1 px-5 py-3 ml-4 box zoom-in" }
const _hoisted_137 = { class: "flex items-center" }
const _hoisted_138 = { class: "font-medium" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "ml-auto text-xs text-slate-500" }, "07:00 PM", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-slate-500" }, "Has joined the team", -1)
const _hoisted_141 = { class: "relative flex items-center mb-3 intro-x" }
const _hoisted_142 = { class: "before:block before:absolute before:w-20 before:h-px before:bg-slate-200 before:dark:bg-darkmode-400 before:mt-5 before:ml-5" }
const _hoisted_143 = { class: "flex-none w-10 h-10 overflow-hidden rounded-full image-fit" }
const _hoisted_144 = ["src"]
const _hoisted_145 = { class: "flex-1 px-5 py-3 ml-4 box zoom-in" }
const _hoisted_146 = { class: "flex items-center" }
const _hoisted_147 = { class: "font-medium" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "ml-auto text-xs text-slate-500" }, "07:00 PM", -1)
const _hoisted_149 = { class: "text-slate-500" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1" }, "Added 3 new photos", -1)
const _hoisted_151 = { class: "flex mt-2" }
const _hoisted_152 = ["src"]
const _hoisted_153 = ["src"]
const _hoisted_154 = ["src"]
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "my-4 text-xs text-center intro-x text-slate-500" }, " 12 November ", -1)
const _hoisted_156 = { class: "relative flex items-center mb-3 intro-x" }
const _hoisted_157 = { class: "before:block before:absolute before:w-20 before:h-px before:bg-slate-200 before:dark:bg-darkmode-400 before:mt-5 before:ml-5" }
const _hoisted_158 = { class: "flex-none w-10 h-10 overflow-hidden rounded-full image-fit" }
const _hoisted_159 = ["src"]
const _hoisted_160 = { class: "flex-1 px-5 py-3 ml-4 box zoom-in" }
const _hoisted_161 = { class: "flex items-center" }
const _hoisted_162 = { class: "font-medium" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "ml-auto text-xs text-slate-500" }, "07:00 PM", -1)
const _hoisted_164 = { class: "mt-1 text-slate-500" }
const _hoisted_165 = {
  class: "text-primary",
  href: ""
}
const _hoisted_166 = { class: "relative flex items-center mb-3 intro-x" }
const _hoisted_167 = { class: "before:block before:absolute before:w-20 before:h-px before:bg-slate-200 before:dark:bg-darkmode-400 before:mt-5 before:ml-5" }
const _hoisted_168 = { class: "flex-none w-10 h-10 overflow-hidden rounded-full image-fit" }
const _hoisted_169 = ["src"]
const _hoisted_170 = { class: "flex-1 px-5 py-3 ml-4 box zoom-in" }
const _hoisted_171 = { class: "flex items-center" }
const _hoisted_172 = { class: "font-medium" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("div", { class: "ml-auto text-xs text-slate-500" }, "07:00 PM", -1)
const _hoisted_174 = { class: "mt-1 text-slate-500" }
const _hoisted_175 = {
  class: "text-primary",
  href: ""
}
const _hoisted_176 = { class: "col-span-12 mt-3 md:col-span-6 xl:col-span-12 xl:col-start-1 xl:row-start-1 2xl:col-start-auto 2xl:row-start-auto" }
const _hoisted_177 = { class: "flex items-center h-10 intro-x" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-auto text-lg font-medium truncate" }, " Important Notes ", -1)
const _hoisted_179 = { class: "mt-5 intro-x" }
const _hoisted_180 = { class: "box zoom-in" }
const _hoisted_181 = { class: "p-5" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-medium truncate" }, " Lorem Ipsum is simply dummy text ", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-slate-400" }, "20 Hours ago", -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-justify text-slate-500" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. ", -1)
const _hoisted_185 = { class: "flex mt-5 font-medium" }
const _hoisted_186 = { class: "p-5" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-medium truncate" }, " Lorem Ipsum is simply dummy text ", -1)
const _hoisted_188 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-slate-400" }, "20 Hours ago", -1)
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-justify text-slate-500" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. ", -1)
const _hoisted_190 = { class: "flex mt-5 font-medium" }
const _hoisted_191 = { class: "p-5" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-medium truncate" }, " Lorem Ipsum is simply dummy text ", -1)
const _hoisted_193 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-slate-400" }, "20 Hours ago", -1)
const _hoisted_194 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-justify text-slate-500" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. ", -1)
const _hoisted_195 = { class: "flex mt-5 font-medium" }
const _hoisted_196 = { class: "col-span-12 mt-3 md:col-span-6 xl:col-span-4 2xl:col-span-12 xl:col-start-1 xl:row-start-2 2xl:col-start-auto 2xl:row-start-auto" }
const _hoisted_197 = { class: "flex items-center h-10 intro-x" }
const _hoisted_198 = /*#__PURE__*/_createElementVNode("h2", { class: "mr-5 text-lg font-medium truncate" }, "Schedules", -1)
const _hoisted_199 = {
  href: "",
  class: "flex items-center ml-auto truncate text-primary"
}
const _hoisted_200 = { class: "mt-5" }
const _hoisted_201 = { class: "intro-x box" }
const _hoisted_202 = { class: "p-5" }
const _hoisted_203 = { class: "flex" }
const _hoisted_204 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto text-base font-medium" }, "April", -1)
const _hoisted_205 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-7 gap-4 mt-5 text-center\"><div class=\"font-medium\">Su</div><div class=\"font-medium\">Mo</div><div class=\"font-medium\">Tu</div><div class=\"font-medium\">We</div><div class=\"font-medium\">Th</div><div class=\"font-medium\">Fr</div><div class=\"font-medium\">Sa</div><div class=\"py-0.5 rounded relative text-slate-500\">29</div><div class=\"py-0.5 rounded relative text-slate-500\">30</div><div class=\"py-0.5 rounded relative text-slate-500\">31</div><div class=\"py-0.5 rounded relative\">1</div><div class=\"py-0.5 rounded relative\">2</div><div class=\"py-0.5 rounded relative\">3</div><div class=\"py-0.5 rounded relative\">4</div><div class=\"py-0.5 rounded relative\">5</div><div class=\"py-0.5 bg-success/20 dark:bg-success/30 rounded relative\"> 6 </div><div class=\"py-0.5 rounded relative\">7</div><div class=\"py-0.5 bg-primary text-white rounded relative\"> 8 </div><div class=\"py-0.5 rounded relative\">9</div><div class=\"py-0.5 rounded relative\">10</div><div class=\"py-0.5 rounded relative\">11</div><div class=\"py-0.5 rounded relative\">12</div><div class=\"py-0.5 rounded relative\">13</div><div class=\"py-0.5 rounded relative\">14</div><div class=\"py-0.5 rounded relative\">15</div><div class=\"py-0.5 rounded relative\">16</div><div class=\"py-0.5 rounded relative\">17</div><div class=\"py-0.5 rounded relative\">18</div><div class=\"py-0.5 rounded relative\">19</div><div class=\"py-0.5 rounded relative\">20</div><div class=\"py-0.5 rounded relative\">21</div><div class=\"py-0.5 rounded relative\">22</div><div class=\"py-0.5 bg-pending/20 dark:bg-pending/30 rounded relative\"> 23 </div><div class=\"py-0.5 rounded relative\">24</div><div class=\"py-0.5 rounded relative\">25</div><div class=\"py-0.5 rounded relative\">26</div><div class=\"py-0.5 bg-primary/10 dark:bg-primary/50 rounded relative\"> 27 </div><div class=\"py-0.5 rounded relative\">28</div><div class=\"py-0.5 rounded relative\">29</div><div class=\"py-0.5 rounded relative\">30</div><div class=\"py-0.5 rounded relative text-slate-500\">1</div><div class=\"py-0.5 rounded relative text-slate-500\">2</div><div class=\"py-0.5 rounded relative text-slate-500\">3</div><div class=\"py-0.5 rounded relative text-slate-500\">4</div><div class=\"py-0.5 rounded relative text-slate-500\">5</div><div class=\"py-0.5 rounded relative text-slate-500\">6</div><div class=\"py-0.5 rounded relative text-slate-500\">7</div><div class=\"py-0.5 rounded relative text-slate-500\">8</div><div class=\"py-0.5 rounded relative text-slate-500\">9</div></div>", 1)
const _hoisted_206 = /*#__PURE__*/_createStaticVNode("<div class=\"p-5 border-t border-slate-200/60\"><div class=\"flex items-center\"><div class=\"w-2 h-2 mr-3 rounded-full bg-pending\"></div><span class=\"truncate\">UI/UX Workshop</span><span class=\"font-medium xl:ml-auto\">23th</span></div><div class=\"flex items-center mt-4\"><div class=\"w-2 h-2 mr-3 rounded-full bg-primary\"></div><span class=\"truncate\"> VueJs Frontend Development </span><span class=\"font-medium xl:ml-auto\">10th</span></div><div class=\"flex items-center mt-4\"><div class=\"w-2 h-2 mr-3 rounded-full bg-warning\"></div><span class=\"truncate\">Laravel Rest API</span><span class=\"font-medium xl:ml-auto\">31th</span></div></div>", 1)

import _ from "lodash";
import { ref, provide, onMounted } from "vue";
import fakerData from "../utils/faker";
import Button from "../base-components/Button";
import Pagination from "../base-components/Pagination";
import TinySlider, { TinySliderElement } from "../base-components/TinySlider";
import Lucide from "../base-components/Lucide";
import Tippy from "../base-components/Tippy";
import Litepicker from "../base-components/Litepicker";
import ReportDonutChart from "../components/ReportDonutChart";
import ReportLineChart from "../components/ReportLineChart";
import ReportPieChart from "../components/ReportPieChart";
import ReportDonutChart1 from "../components/ReportDonutChart1";
import SimpleLineChart1 from "../components/SimpleLineChart1";
import { Menu } from "../base-components/Headless";
import Table from "../base-components/Table";
import { Dialog } from "@/base-components/Headless";
import {
  getToolTipsTranslationIds,
  getToolHintsTranslationIds,
} from "@/services/data/data.service";
import * as introJs from "../../node_modules/intro.js/intro";
import {
  fetchHarnessUsers,
  getEntityData,
  getRegistrationForm,
  registerUser,
  fetchHarnessLog,
  saveSyncEvent,
  getEntities,
} from "@/services/backend/backend.service";
import {
  FormLabel,
  FormSelect,
  FormInput
} from "../base-components/Form";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardOverview1',
  setup(__props) {

const toolTips = ref([]);
const toolHints = ref([]);
const componentId = ref("");
const entityData = ref([]);
const entityId = ref("");
const schema = ref("");
const manifest = ref([]);
const users = ref([]);
const removedUsers = ref([]);
const uniqueUsers = ref([]);
const iteration = ref(0);
const registrationRequested = ref(false);
const entities = ref([]);
const selectedEntity = ref("");

const salesReportFilter = ref<string>("");
const importantNotesRef = ref<TinySliderElement>();
const requestJson = {
  request: {
    options: {
      // @ts-ignore
      query: {
        attributes: {},
      },
    },
  },
};
requestJson.request.options.query.attributes.all_entities =
  "3126401318927740926";

onMounted(async () => {
  try {
    /*
    const secret = JSON.parse(localStorage.getItem("vuex")).secret;
    entityData.value = await getEntityData(secret);

    entityId.value = entityData;*/
    /* eslint-disable-next-line */
    /*
    var data = entityData._rawValue;
    var ip = data[0].split(":")[0];
    var port = data[0].split(":")[1];*/
    var port = "3307";
    var ip = "127.0.0.2";
    schema.value = "dev";
    //manifest.value = await getRegistrationForm(ip, port, schema.value);
    componentId.value = "26997";
    toolTips.value[115834] =  "firstName";
    //toolTips.value = await getToolTipsTranslationIds(componentId.value);
    //toolHints.value = await getToolHintsTranslationIds(componentId.value);
    window.addEventListener("message", (event) => awaitEvent(event), false);
  } catch (error) {
    console.log("Error caught", error);
  }
});
async function fetchLog() {
  iteration.value = 0;
  let pageIndex = 0;
  const currentDate = new Date();
  const startTime = 0;
  const endTime = currentDate.getTime();
  const log = await fetchHarnessLog(startTime, endTime, pageIndex);
  log.data.content.forEach(
    (action: { action: string; resource: { identifier: any } }) => {
      if (action.action == "ADD_COLLABORATOR") {
        users.value.push(action.resource.identifier);
      } else if (action.action == "REMOVE_COLLABORATOR") {
        removedUsers.value.push(action.resource.identifier);
      }
    }
  );
  pageIndex++;
  while (pageIndex < log.data.totalPages) {
    const extraLog = fetchHarnessLog(startTime, endTime, pageIndex);
    //@ts-ignore
    extraLog.data.content.forEach(
      (action: { action: string; resource: { identifier: any } }) => {
        if (action.action == "ADD_COLLABORATOR") {
          users.value.push(action.resource.identifier);
        } else if (action.action == "REMOVE_COLLABORATOR") {
          removedUsers.value.push(action.resource.identifier);
        }
      }
    );
    pageIndex++;
  }
  const neededUsers =  users.value.filter( ( el:any ) => !removedUsers.value.includes( el ) );
  uniqueUsers.value = [...new Set(neededUsers)];
  entities.value = await getEntities(JSON.stringify(requestJson));
  registrationRequested.value = true;
}
function getDataForNewField(id: string, formData: []) {
  var label = "";
  var typeId = "";
  var categoryId = "";
  var classId = "";
  var parentId = "";
  for (var i = 0; i < formData.length; i++) {
    if (formData[i][7] == id) {
      label = formData[i][1];
      typeId = formData[i][2];
      categoryId = formData[i][3];
      classId = formData[i][4];
      parentId = formData[i][5];
    }
  }
  return [label, typeId, categoryId, classId, parentId];
}

function getDataForInsert(id: string, manifest: any) {
  return getDataForNewField(id, manifest.value);
}

async function register(data: any) {
  var response = await registerUser(data);
  iteration.value++;
  console.log(response);
  if (iteration.value == uniqueUsers.value.length) {
    users.value = [];
    removedUsers.value = [];
    saveEvent();
  }
}

async function saveEvent() {
  // uniqueness - token? user based(user id)?
  const response = await saveSyncEvent();
  return response;
}

async function registerUsers(users: Array<string>, selectedEntity: string) {
  if (users.length > 0) {
    users.forEach((user) => {
      const formData = new FormData();
      formData.set("username", user.toString());
      formData.set("email", user.toString());
      const password = Math.random().toString(36).substring(2);
      formData.set("firstPassword", password);
      formData.set(
        "extravalue1",
        getDataForInsert("3125750820360946953", manifest)
      );
      formData.set("extravalue2", getDataForInsert("115841", manifest));
      formData.set(
        "extravalue3",
        getDataForInsert("3125750820360946945", manifest)
      );
      // @ts-ignore
      formData.set("entityId", selectedEntity.value);
      /* eslint-disable-next-line */
      //formData.set("ipAndPort", entityData._rawValue[0]);
      formData.set("schema", schema.value);
      // @ts-ignore
      formData.set("profile", selectedEntity.value);
      register(formData);
    });
  } else {
    console.log("No users to register!");
  }
}

function selectEntity(event: any) {
  selectedEntity.value = event.target.value;
}
async function registration() {
  hideModal();
  // @ts-ignore
  registerUsers(uniqueUsers.value, selectedEntity);
}

provide("bind[importantNotesRef]", (el: TinySliderElement) => {
  importantNotesRef.value = el;
});

const prevImportantNotes = () => {
  importantNotesRef.value?.tns.goTo("prev");
};
const nextImportantNotes = () => {
  importantNotesRef.value?.tns.goTo("next");
};
const hideModal = () => {
  registrationRequested.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Dialog), {
      open: registrationRequested.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (hideModal()))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog).Panel, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Lucide), {
                icon: "HelpCircle",
                class: "w-16 h-16 mx-auto mt-3 text-success"
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(FormLabel), { htmlFor: "modal-form-6" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Select entity to register user:")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormSelect), {
                  id: "modal-form-6",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (selectEntity($event)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entities.value, (entity) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: entity.id,
                        value: entity.id
                      }, _toDisplayString(entity.text), 9, _hoisted_4))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Button), {
                type: "button",
                variant: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (registration())),
                class: "w-24"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Ok ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            (toolTips.value.length > 0)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "flex items-center text-primary",
                  "data-intro": _ctx.$t(toolTips.value[115834])
                }, " Hint test ", 8, _hoisted_11))
              : _createCommentVNode("", true),
            _createElementVNode("a", _hoisted_12, [
              _createVNode(_unref(Lucide), {
                icon: "RefreshCcw",
                class: "w-4 h-4 mr-3"
              }),
              _createTextVNode(" Reload Data ")
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(Lucide), {
                      icon: "ShoppingCart",
                      class: "w-[28px] h-[28px] text-primary"
                    }),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_unref(Tippy), {
                        as: "div",
                        class: "cursor-pointer bg-success py-[3px] flex rounded-full text-white text-xs pl-2 pr-1 items-center font-medium",
                        content: "33% Higher than last month"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 33% "),
                          _createVNode(_unref(Lucide), {
                            icon: "ChevronUp",
                            class: "w-4 h-4 ml-0.5"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_19,
                  _hoisted_20
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(Lucide), {
                      icon: "CreditCard",
                      class: "w-[28px] h-[28px] text-pending"
                    }),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_unref(Tippy), {
                        as: "div",
                        class: "cursor-pointer bg-danger py-[3px] flex rounded-full text-white text-xs pl-2 pr-1 items-center font-medium",
                        content: "2% Lower than last month"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 2% "),
                          _createVNode(_unref(Lucide), {
                            icon: "ChevronDown",
                            class: "w-4 h-4 ml-0.5"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_26,
                  _hoisted_27
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_unref(Lucide), {
                      icon: "Monitor",
                      class: "w-[28px] h-[28px] text-warning"
                    }),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_unref(Tippy), {
                        as: "div",
                        class: "cursor-pointer bg-success py-[3px] flex rounded-full text-white text-xs pl-2 pr-1 items-center font-medium",
                        content: "12% Higher than last month"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 12% "),
                          _createVNode(_unref(Lucide), {
                            icon: "ChevronUp",
                            class: "w-4 h-4 ml-0.5"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_33,
                  _hoisted_34
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_unref(Lucide), {
                      icon: "User",
                      class: "w-[28px] h-[28px] text-success"
                    }),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_unref(Tippy), {
                        as: "div",
                        class: "cursor-pointer bg-success py-[3px] flex rounded-full text-white text-xs pl-2 pr-1 items-center font-medium",
                        content: "22% Higher than last month"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 22% "),
                          _createVNode(_unref(Lucide), {
                            icon: "ChevronUp",
                            class: "w-4 h-4 ml-0.5"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_40,
                  _hoisted_41
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_unref(Lucide), {
                icon: "Calendar",
                class: "absolute inset-y-0 left-0 z-10 w-4 h-4 my-auto ml-3"
              }),
              _createVNode(_unref(Litepicker), {
                modelValue: salesReportFilter.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((salesReportFilter).value = $event)),
                options: {
                  autoApply: false,
                  singleMode: false,
                  numberOfColumns: 2,
                  numberOfMonths: 2,
                  showWeekNumbers: true,
                  dropdowns: {
                    minYear: 1990,
                    maxYear: null,
                    months: true,
                    years: true,
                  },
                },
                class: "pl-10 sm:w-56 !box"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createVNode(_unref(Menu), { class: "mt-5 md:ml-auto md:mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Menu).Button, {
                    as: _unref(Button),
                    variant: "outline-secondary",
                    class: "font-normal"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Filter by Category "),
                      _createVNode(_unref(Lucide), {
                        icon: "ChevronDown",
                        class: "w-4 h-4 ml-2"
                      })
                    ]),
                    _: 1
                  }, 8, ["as"]),
                  _createVNode(_unref(Menu).Items, { class: "w-40 h-32 overflow-y-auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Menu).Item, null, {
                        default: _withCtx(() => [
                          _createTextVNode("PC & Laptop")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Menu).Item, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Smartphone")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Menu).Item, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Electronic")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Menu).Item, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Photography")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Menu).Item, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Sport")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_unref(ReportLineChart), {
                height: 275,
                class: "mt-6 -mb-6"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_unref(ReportPieChart), { height: 213 })
            ]),
            _hoisted_54
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_unref(ReportDonutChart), { height: 213 })
            ]),
            _hoisted_59
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_unref(Lucide), {
                icon: "MapPin",
                class: "absolute inset-y-0 left-0 z-10 w-4 h-4 my-auto ml-3"
              }),
              _createVNode(_unref(FormInput), {
                type: "text",
                class: "pl-10 sm:w-56 !box",
                placeholder: "Filter by city"
              })
            ])
          ]),
          _hoisted_64
        ]),
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createElementVNode("div", _hoisted_67, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_).take(_unref(fakerData), 4), (faker, fakerKey) => {
              return (_openBlock(), _createElementBlock("div", {
                key: fakerKey,
                class: "intro-y"
              }, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("img", {
                      alt: "Midone Tailwind HTML Admin Template",
                      src: faker.photos[0]
                    }, null, 8, _hoisted_70)
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, _toDisplayString(faker.users[0].name), 1),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(faker.dates[0]), 1)
                  ]),
                  _hoisted_74
                ])
              ]))
            }), 128)),
            _hoisted_75
          ])
        ]),
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("div", _hoisted_81, [
                  _createVNode(_unref(ReportDonutChart1), {
                    width: 90,
                    height: 90
                  }),
                  _hoisted_82
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _hoisted_85,
              _createElementVNode("div", _hoisted_86, [
                _createVNode(_unref(SimpleLineChart1), {
                  height: 58,
                  class: "-ml-1"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _hoisted_90,
                _createElementVNode("div", _hoisted_91, [
                  _createVNode(_unref(ReportDonutChart1), {
                    width: 90,
                    height: 90
                  }),
                  _hoisted_92
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _hoisted_95,
              _createElementVNode("div", _hoisted_96, [
                _createVNode(_unref(SimpleLineChart1), {
                  height: 58,
                  class: "-ml-1"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("div", _hoisted_98, [
            _hoisted_99,
            _createElementVNode("div", _hoisted_100, [
              _createVNode(_unref(Button), { class: "flex items-center !box text-slate-600 dark:text-slate-300" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Lucide), {
                    icon: "FileText",
                    class: "hidden w-4 h-4 mr-2 sm:block"
                  }),
                  _createTextVNode(" Export to Excel ")
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), { class: "flex items-center ml-3 !box text-slate-600 dark:text-slate-300" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Lucide), {
                    icon: "FileText",
                    class: "hidden w-4 h-4 mr-2 sm:block"
                  }),
                  _createTextVNode(" Export to PDF ")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _createVNode(_unref(Table), { class: "border-spacing-y-[10px] border-separate sm:mt-2" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Table).Thead, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Table).Tr, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Table).Th, { class: "border-b-0 whitespace-nowrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" IMAGES ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Table).Th, { class: "border-b-0 whitespace-nowrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" PRODUCT NAME ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Table).Th, { class: "text-center border-b-0 whitespace-nowrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" STOCK ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Table).Th, { class: "text-center border-b-0 whitespace-nowrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" STATUS ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Table).Th, { class: "text-center border-b-0 whitespace-nowrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" ACTIONS ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Table).Tbody, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_).take(_unref(fakerData), 4), (faker, fakerKey) => {
                      return (_openBlock(), _createBlock(_unref(Table).Tr, {
                        key: fakerKey,
                        class: "intro-x"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Table).Td, { class: "first:rounded-l-md last:rounded-r-md w-40 bg-white border-b-0 dark:bg-darkmode-600 shadow-[20px_3px_20px_#0000000b]" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("div", _hoisted_103, [
                                  _createVNode(_unref(Tippy), {
                                    as: "img",
                                    alt: "Midone Tailwind HTML Admin Template",
                                    class: "rounded-full shadow-[0px_0px_0px_2px_#fff,_1px_1px_5px_rgba(0,0,0,0.32)] dark:shadow-[0px_0px_0px_2px_#3f4865,_1px_1px_5px_rgba(0,0,0,0.32)]",
                                    src: faker.images[0],
                                    content: `Uploaded at ${faker.dates[0]}`
                                  }, null, 8, ["src", "content"])
                                ]),
                                _createElementVNode("div", _hoisted_104, [
                                  _createVNode(_unref(Tippy), {
                                    as: "img",
                                    alt: "Midone Tailwind HTML Admin Template",
                                    class: "rounded-full shadow-[0px_0px_0px_2px_#fff,_1px_1px_5px_rgba(0,0,0,0.32)] dark:shadow-[0px_0px_0px_2px_#3f4865,_1px_1px_5px_rgba(0,0,0,0.32)]",
                                    src: faker.images[1],
                                    content: `Uploaded at ${faker.dates[1]}`
                                  }, null, 8, ["src", "content"])
                                ]),
                                _createElementVNode("div", _hoisted_105, [
                                  _createVNode(_unref(Tippy), {
                                    as: "img",
                                    alt: "Midone Tailwind HTML Admin Template",
                                    class: "rounded-full shadow-[0px_0px_0px_2px_#fff,_1px_1px_5px_rgba(0,0,0,0.32)] dark:shadow-[0px_0px_0px_2px_#3f4865,_1px_1px_5px_rgba(0,0,0,0.32)]",
                                    src: faker.images[2],
                                    content: `Uploaded at ${faker.dates[2]}`
                                  }, null, 8, ["src", "content"])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(Table).Td, { class: "first:rounded-l-md last:rounded-r-md bg-white border-b-0 dark:bg-darkmode-600 shadow-[20px_3px_20px_#0000000b]" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_106, _toDisplayString(faker.products[0].name), 1),
                              _createElementVNode("div", _hoisted_107, _toDisplayString(faker.products[0].category), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(Table).Td, { class: "first:rounded-l-md last:rounded-r-md text-center bg-white border-b-0 dark:bg-darkmode-600 shadow-[20px_3px_20px_#0000000b]" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(faker.stocks[0]), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(Table).Td, { class: "first:rounded-l-md last:rounded-r-md w-40 bg-white border-b-0 dark:bg-darkmode-600 shadow-[20px_3px_20px_#0000000b]" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass([
                        'flex items-center justify-center',
                        { 'text-success': faker.trueFalse[0] },
                        { 'text-danger': !faker.trueFalse[0] },
                      ])
                              }, [
                                _createVNode(_unref(Lucide), {
                                  icon: "CheckSquare",
                                  class: "w-4 h-4 mr-2"
                                }),
                                _createTextVNode(" " + _toDisplayString(faker.trueFalse[0] ? "Active" : "Inactive"), 1)
                              ], 2)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(Table).Td, { class: "first:rounded-l-md last:rounded-r-md w-56 bg-white border-b-0 dark:bg-darkmode-600 shadow-[20px_3px_20px_#0000000b] py-0 relative before:block before:w-px before:h-8 before:bg-slate-200 before:absolute before:left-0 before:inset-y-0 before:my-auto before:dark:bg-darkmode-400" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_108, [
                                _createElementVNode("a", _hoisted_109, [
                                  _createVNode(_unref(Lucide), {
                                    icon: "CheckSquare",
                                    class: "w-4 h-4 mr-1"
                                  }),
                                  _createTextVNode(" Edit ")
                                ]),
                                _createElementVNode("a", _hoisted_110, [
                                  _createVNode(_unref(Lucide), {
                                    icon: "Trash2",
                                    class: "w-4 h-4 mr-1"
                                  }),
                                  _createTextVNode(" Delete ")
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_111, [
            _createVNode(_unref(Pagination), { class: "w-full sm:w-auto sm:mr-auto" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Pagination).Link, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Lucide), {
                      icon: "ChevronsLeft",
                      class: "w-4 h-4"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Pagination).Link, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Lucide), {
                      icon: "ChevronLeft",
                      class: "w-4 h-4"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Pagination).Link, null, {
                  default: _withCtx(() => [
                    _createTextVNode("...")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Pagination).Link, null, {
                  default: _withCtx(() => [
                    _createTextVNode("1")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Pagination).Link, { active: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("2")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Pagination).Link, null, {
                  default: _withCtx(() => [
                    _createTextVNode("3")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Pagination).Link, null, {
                  default: _withCtx(() => [
                    _createTextVNode("...")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Pagination).Link, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Lucide), {
                      icon: "ChevronRight",
                      class: "w-4 h-4"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Pagination).Link, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Lucide), {
                      icon: "ChevronsRight",
                      class: "w-4 h-4"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(FormSelect), { class: "w-20 mt-3 !box sm:mt-0" }, {
              default: _withCtx(() => [
                _hoisted_112,
                _hoisted_113,
                _hoisted_114,
                _hoisted_115
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_116, [
      _createElementVNode("div", _hoisted_117, [
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("div", _hoisted_119, [
            _hoisted_120,
            _createElementVNode("div", _hoisted_121, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_).take(_unref(fakerData), 5), (faker, fakerKey) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: fakerKey,
                  class: "intro-x"
                }, [
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("img", {
                        alt: "Midone Tailwind HTML Admin Template",
                        src: faker.photos[0]
                      }, null, 8, _hoisted_124)
                    ]),
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, _toDisplayString(faker.users[0].name), 1),
                      _createElementVNode("div", _hoisted_127, _toDisplayString(faker.dates[0]), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass({
                      'text-success': faker.trueFalse[0],
                      'text-danger': !faker.trueFalse[0],
                    })
                    }, _toDisplayString(faker.trueFalse[0] ? "+" : "-") + "$" + _toDisplayString(faker.totals[0]), 3)
                  ])
                ]))
              }), 128)),
              _hoisted_128
            ])
          ]),
          _createElementVNode("div", _hoisted_129, [
            _hoisted_130,
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("img", {
                      alt: "Midone Tailwind HTML Admin Template",
                      src: _unref(fakerData)[9].photos[0]
                    }, null, 8, _hoisted_135)
                  ])
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, _toDisplayString(_unref(fakerData)[9].users[0].name), 1),
                    _hoisted_139
                  ]),
                  _hoisted_140
                ])
              ]),
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _createElementVNode("img", {
                      alt: "Midone Tailwind HTML Admin Template",
                      src: _unref(fakerData)[8].photos[0]
                    }, null, 8, _hoisted_144)
                  ])
                ]),
                _createElementVNode("div", _hoisted_145, [
                  _createElementVNode("div", _hoisted_146, [
                    _createElementVNode("div", _hoisted_147, _toDisplayString(_unref(fakerData)[8].users[0].name), 1),
                    _hoisted_148
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _hoisted_150,
                    _createElementVNode("div", _hoisted_151, [
                      _createVNode(_unref(Tippy), {
                        as: "div",
                        class: "w-8 h-8 mr-1 image-fit zoom-in",
                        content: _unref(fakerData)[0].products[0].name
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            alt: "Midone Tailwind HTML Admin Template",
                            class: "border border-white rounded-md",
                            src: _unref(fakerData)[8].images[0]
                          }, null, 8, _hoisted_152)
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _createVNode(_unref(Tippy), {
                        as: "div",
                        class: "w-8 h-8 mr-1 image-fit zoom-in",
                        content: _unref(fakerData)[1].products[0].name
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            alt: "Midone Tailwind HTML Admin Template",
                            class: "border border-white rounded-md",
                            src: _unref(fakerData)[8].images[1]
                          }, null, 8, _hoisted_153)
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _createVNode(_unref(Tippy), {
                        as: "div",
                        class: "w-8 h-8 mr-1 image-fit zoom-in",
                        content: _unref(fakerData)[2].products[0].name
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            alt: "Midone Tailwind HTML Admin Template",
                            class: "border border-white rounded-md",
                            src: _unref(fakerData)[8].images[2]
                          }, null, 8, _hoisted_154)
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ])
                  ])
                ])
              ]),
              _hoisted_155,
              _createElementVNode("div", _hoisted_156, [
                _createElementVNode("div", _hoisted_157, [
                  _createElementVNode("div", _hoisted_158, [
                    _createElementVNode("img", {
                      alt: "Midone Tailwind HTML Admin Template",
                      src: _unref(fakerData)[7].photos[0]
                    }, null, 8, _hoisted_159)
                  ])
                ]),
                _createElementVNode("div", _hoisted_160, [
                  _createElementVNode("div", _hoisted_161, [
                    _createElementVNode("div", _hoisted_162, _toDisplayString(_unref(fakerData)[7].users[0].name), 1),
                    _hoisted_163
                  ]),
                  _createElementVNode("div", _hoisted_164, [
                    _createTextVNode(" Has changed "),
                    _createElementVNode("a", _hoisted_165, _toDisplayString(_unref(fakerData)[7].products[0].name), 1),
                    _createTextVNode(" price and description ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("img", {
                      alt: "Midone Tailwind HTML Admin Template",
                      src: _unref(fakerData)[6].photos[0]
                    }, null, 8, _hoisted_169)
                  ])
                ]),
                _createElementVNode("div", _hoisted_170, [
                  _createElementVNode("div", _hoisted_171, [
                    _createElementVNode("div", _hoisted_172, _toDisplayString(_unref(fakerData)[6].users[0].name), 1),
                    _hoisted_173
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    _createTextVNode(" Has changed "),
                    _createElementVNode("a", _hoisted_175, _toDisplayString(_unref(fakerData)[6].products[0].name), 1),
                    _createTextVNode(" description ")
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_176, [
            _createElementVNode("div", _hoisted_177, [
              _hoisted_178,
              _createVNode(_unref(Button), {
                "data-carousel": "important-notes",
                "data-target": "prev",
                class: "px-2 mr-2 border-slate-300 text-slate-600 dark:text-slate-300",
                onClick: prevImportantNotes
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Lucide), {
                    icon: "ChevronLeft",
                    class: "w-4 h-4"
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                "data-carousel": "important-notes",
                "data-target": "next",
                class: "px-2 mr-2 border-slate-300 text-slate-600 dark:text-slate-300",
                onClick: nextImportantNotes
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Lucide), {
                    icon: "ChevronRight",
                    class: "w-4 h-4"
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_179, [
              _createElementVNode("div", _hoisted_180, [
                _createVNode(_unref(TinySlider), { refKey: "importantNotesRef" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_181, [
                      _hoisted_182,
                      _hoisted_183,
                      _hoisted_184,
                      _createElementVNode("div", _hoisted_185, [
                        _createVNode(_unref(Button), {
                          variant: "secondary",
                          type: "button",
                          class: "px-2 py-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" View Notes ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Button), {
                          variant: "outline-secondary",
                          type: "button",
                          class: "px-2 py-1 ml-auto"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Dismiss ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_186, [
                      _hoisted_187,
                      _hoisted_188,
                      _hoisted_189,
                      _createElementVNode("div", _hoisted_190, [
                        _createVNode(_unref(Button), {
                          variant: "secondary",
                          type: "button",
                          class: "px-2 py-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" View Notes ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Button), {
                          variant: "outline-secondary",
                          type: "button",
                          class: "px-2 py-1 ml-auto"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Dismiss ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_191, [
                      _hoisted_192,
                      _hoisted_193,
                      _hoisted_194,
                      _createElementVNode("div", _hoisted_195, [
                        _createVNode(_unref(Button), {
                          variant: "secondary",
                          type: "button",
                          class: "px-2 py-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" View Notes ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Button), {
                          variant: "outline-secondary",
                          type: "button",
                          class: "px-2 py-1 ml-auto"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Dismiss ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_196, [
            _createElementVNode("div", _hoisted_197, [
              _hoisted_198,
              _createElementVNode("a", _hoisted_199, [
                _createVNode(_unref(Lucide), {
                  icon: "Plus",
                  class: "w-4 h-4 mr-1"
                }),
                _createTextVNode(" Add New Schedules ")
              ])
            ]),
            _createElementVNode("div", _hoisted_200, [
              _createElementVNode("div", _hoisted_201, [
                _createElementVNode("div", _hoisted_202, [
                  _createElementVNode("div", _hoisted_203, [
                    _createVNode(_unref(Lucide), {
                      icon: "ChevronLeft",
                      class: "w-5 h-5 text-slate-500"
                    }),
                    _hoisted_204,
                    _createVNode(_unref(Lucide), {
                      icon: "ChevronRight",
                      class: "w-5 h-5 text-slate-500"
                    })
                  ]),
                  _hoisted_205
                ]),
                _hoisted_206
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})